/** @format */

import {type MouseEvent, useState} from 'react';

import {Box} from '@mui/material';

import {StyledPopover} from 'pages/HomeGrouping/components/StyledPopover';
import {type StatusDataInterface} from 'pages/HomeGrouping/types';

import {StatusBadgeRoot} from './styles';

interface Props {
  data: StatusDataInterface;
}

/**
 * Overview-native project status badge — a systemic capsule (32px, p14 text, semantic_dark colors
 * by variant) with a trailing help icon that opens the status explanation popover on click.
 *
 * It does NOT reuse HomeGrouping's ProjectStatus: that component is styled for the legacy palette /
 * 28px height and is shared with other pages, so a copy here keeps the overview badges consistent.
 */
export function StatusBadge({data}: Props) {
  const {title, variant = 'default', PopoverContent, projectTitle} = data;

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleOpen = (event: MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  return (
    <StatusBadgeRoot
      colorscheme={variant}
      onClick={handleOpen}
      data-testid={`status-badge-${projectTitle}-${title}`}
    >
      <Box component='span'>{title}</Box>
      <Box component='span' className='material-symbols-outlined'>
        help
      </Box>

      <StyledPopover open={Boolean(anchorEl)} anchorEl={anchorEl} onClose={handleClose}>
        {PopoverContent}
      </StyledPopover>
    </StatusBadgeRoot>
  );
}
